"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerList = void 0;
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const ledgerReport_1 = require("./components/ledgerReport");
let LedgerList = class LedgerList extends react_1.Component {
    render() {
        return React.createElement(ledgerReport_1.LedgerReport, null);
    }
};
LedgerList = __decorate([
    mobx_react_1.observer
], LedgerList);
exports.LedgerList = LedgerList;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/ledger-list.tsx
// module id = 3710
// module chunks = 0